import { render, staticRenderFns } from "./NursingCareLeaveDetail.vue?vue&type=template&id=601fefba&"
import script from "./NursingCareLeaveDetail.vue?vue&type=script&lang=js&"
export * from "./NursingCareLeaveDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports